import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Router,
  RouterProvider,
  Routes,
} from "react-router-dom";
import { ProtectedRoute } from "./routes/helpers";
import Organisation from "./routes/org";
import Login from "./routes/login";
import Bands from "./routes/bands";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import Posts from "./routes/posts";
import Post from "./routes/post/edit";
import Editions from "./routes/editions";
import EditionBands from "./routes/editionsBands";
import { ImageEditor } from "./routes/band/imageEdit";
import CreatePost from "./routes/post/create";
import Booking from "./routes/booking/edit";
import EditBooking from "./routes/booking/edit";
import CreateBooking from "./routes/booking/create";
import Stages from "./routes/stages";
import Stage from "./routes/stage";
import Band from "./routes/band/edit";
import Edition from "./routes/edition/edit";
import CreateEdition from "./routes/edition/create";
import { SendNotification } from "./routes/notification";
import Landing from "./routes/landing";
import { Settings } from "./routes/settings";
import NotificationHistory from "./routes/notifications";
import ShowcaseBands from "./routes/showcase";
import Users from "./routes/users";
import Drinks from "./routes/drinks";
import CreateUser from "./routes/users/create";
import EditUser from "./routes/users/edit";
import Links from "./routes/links";
import ImageSelection from "./routes/images";
import ThemeEditor from "./routes/themeEditor";
import CreateStage from "./routes/stage/create";
import Areas from "./routes/areas";
// import Branding from "./routes/images/preview";
// import Icons from "./routes/images/icons";
// import Theme from "./routes/images/theme";
import { Config as Meta } from "./routes/meta";
// import { ViewConfig as ViewMeta } from "./routes/meta/view";
import { ManageConfig } from "./routes/config";
import { CreateAppConfig } from "./routes/meta/config/create";
import Vendors from "./routes/vendors";
import CreateVendor from "./routes/vendors/vendor/create";
import Vendor from "./routes/vendors/vendor/edit";
import { Map } from "./routes/map/index";
import { InteractiveMapEditor } from "./routes/map/InteractiveMapEditor";
import { InteractiveMapPage } from "./routes/map/InteractiveMapPage";
import { PrintMap } from "./routes/map/PrintMap";
import { InfoPage } from "./routes/info";
import { EditInfo } from "./routes/info/edit";
import Sponsors from "./routes/sponsors";
import CreateSponsor from "./routes/sponsor/create";
import Sponsor from "./routes/sponsor";
import EditEditionBands from "./routes/editEditionsBands";
import Polls from "./routes/polls";
import PollLink from "./routes/polls/polls/Polls";
import PollResultsPage from "./routes/polls/PollResults";
import Linker from "./routes/login/Linker";
import { Importer } from "./components/Importer";
import Clashfinder from "./routes/clashfinder";
import { ClashfinderContainer } from "./routes/clashfinder/Container";
import { Announcements } from "./routes/announcement/Announcements";
import { CreateUpdateAnnouncement } from "./routes/announcement/CreateUpdateAnnouncement";
import AnnouncementBands from "./routes/announcementBands";
import CsvImportTabs from "./routes/csvImport/CsvImportTabs";
import HelpIndex from "./routes/help";
import HelpDetail from "./routes/help/HelpDetail";
import Analytics from "./routes/analytics";
import ActiveUsersPage from "./routes/analytics/ActiveUsersPage";
import SelectBandPage from "./routes/analytics/SelectBandPage";
import EngagementPage from "./routes/analytics/EngagementPage";
import CityActiveUsersPage from "./routes/analytics/CityActiveUsersPage";
import PlatformSharePage from "./routes/analytics/PlatformSharePage";
import AppVersionPage from "./routes/analytics/AppVersionPage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/login" element={<Login />} />
      <Route path="/login/link" element={<Linker />} />
      <Route path="/login/link/:link" element={<Linker />} />
      <Route element={<ProtectedRoute />}>
        <Route key="route_landing" index element={<Landing />} />
        <Route key="route_landing_path" path="/landing" element={<Landing />} />
        <Route key="route_news" path="/news" element={<Posts />} />
        <Route key="route_ceate" path="/post/create" element={<CreatePost />} />
        <Route key="route_post_id" path="/post/:id" element={<Post />} />
        <Route key="route_bands" path="/bands" element={<Bands />} />
        <Route key="route_band_id" path="/band/:id" element={<Band />} />
        <Route
          key="route_showcase"
          path="/showcase"
          element={<ShowcaseBands />}
        />
        <Route key="route_editions" path="/editions" element={<Editions />} />
        <Route key="route_edition_announcements" path="/edition/:editionId/announcements" element={<Announcements />} />
        <Route key="route_announcement_edit" path="/announcement/edit/:editionId/:announcementId" element={<CreateUpdateAnnouncement />} />
        <Route key="route_announcement_create" path="/announcement/edit/:editionId" element={<CreateUpdateAnnouncement />} />
        <Route key="route_announcement" path="/announcement/:announcementId" element={<AnnouncementBands />} />
        
        <Route
          key="route_edition_edit"
          path="/edition/edit/:id"
          element={<Edition />}
        />
        <Route
          key="route_clashfinder_view"
          path="/clashfinder/:id"
          element={<ClashfinderContainer />}
        />
        <Route
          key="route_edition_create"
          path="/edition/create"
          element={<CreateEdition />}
        />
        <Route
          key="route_edition_id"
          path="/edition/:id"
          element={<EditionBands />}
        />
        <Route
          key="route_booking_create"
          path="/booking/create"
          element={<CreateBooking />}
        />
        <Route
          key="route_booking_create"
          path="/booking/create/:date"
          element={<CreateBooking />}
        />
        <Route
          key="route_booking_id"
          path="/booking/:id"
          element={<EditBooking />}
        />
        <Route key="route_stages" path="/stages" element={<Stages />} />
        <Route
          key="route_stage_id"
          path="/stage/create"
          element={<CreateStage />}
        />
        <Route key="route_stage_id" path="/stage/:id" element={<Stage />} />
        <Route key="route_areas" path="/areas" element={<Areas />} />
        <Route key="route_image" path="/image" element={<ImageEditor />} />
        <Route
          key="route_notifications"
          path="/notifications"
          element={<SendNotification />}
        />
        <Route
          key="route_notifications"
          path="/notifications/:id"
          element={<SendNotification />}
        />
        <Route
          key="route_notifications"
          path="/notifications?postId=:postId"
          element={<SendNotification />}
        />
        <Route
          key="route_notifications"
          path="/notification/history"
          element={<NotificationHistory />}
        />
        <Route key="route_settings" path="/settings" element={<Settings />} />
        <Route
          key="route_settings"
          path="/settings/link/:link"
          element={<Settings />}
        />
        <Route key="route_analytics" path="/analytics" element={<Analytics />} />
        <Route
          key="route_analytics_active_users"
          path="/analytics/active-users"
          element={<ActiveUsersPage />}
        />
        <Route
          key="route_analytics_select_band"
          path="/analytics/select-band"
          element={<SelectBandPage />}
        />
        <Route
          key="route_analytics_engagement"
          path="/analytics/engagement"
          element={<EngagementPage />}
        />
        <Route
          key="route_analytics_cities"
          path="/analytics/cities"
          element={<CityActiveUsersPage />}
        />
        <Route
          key="route_analytics_platforms"
          path="/analytics/platforms"
          element={<PlatformSharePage />}
        />
        <Route
          key="route_analytics_app_versions"
          path="/analytics/app-versions"
          element={<AppVersionPage />}
        />
        <Route key="route_users" path="/users" element={<Users />} />        
        <Route key="route_users" path="/user/create" element={<CreateUser />} />        
        <Route key="route_users" path="/user/edit/:id" element={<EditUser />} />
        <Route key="route_drinks" path="/drinks" element={<Drinks />} />
        <Route key="route_links" path="/links" element={<Links />} />
        <Route
          key="route_information"
          path="/information"
          element={<InfoPage />}
        />
        <Route
          key="route_information_edit"
          path="/information/edit/:id"
          element={<EditInfo />}
        />
        <Route
          key="route_image_editor"
          path="/image-tools"
          element={<ImageSelection />}
        />
        <Route
          key="route_theme_editor"
          path="/theme-editor"
          element={<ThemeEditor />}
        />
        {/* <Route key="route_branding" path="/branding" element={<Branding />} /> */}
        {/* <Route key="route_theme" path="/theme" element={<Theme />} /> */}
        {/* <Route key="route_icons" path="/icons" element={<Icons />} /> */}
        {/* <Route
              key="route_meta_config"
              path="/meta/config"
              element={<Meta />}
            />
            <Route
              key="route_create_meta_config"
              path="/meta/create"
              element={<CreateAppConfig />}
            /> */}
        {/* <Route
              key="route_view_meta_config"
              path="/meta/config/:id"
              element={<ViewMeta />}
            /> */}

        <Route key="route_config" path="/config" element={<ManageConfig />} />
        <Route key="vendor" path="/vendors" element={<Vendors />} />
        <Route
          key="route_vendor_create"
          path="/vendor/create"
          element={<CreateVendor />}
        />
        <Route
          key="route_vendor_edit"
          path="/vendor/:id"
          element={<Vendor />}
        />
        <Route key="map" path="/map" element={<Map />} />
        <Route
          key="map_interactive"
          path="/map/interactive"
          element={<InteractiveMapPage />}
        />
        <Route key="map_print" path="/map/print" element={<PrintMap />} />
        <Route key="route_band_id" path="/band/" element={<Band />} />
        <Route key="route_band_id" path="/band/:id" element={<Band />} />
        {/* <Route key="route_view_config" path="/config/:id" element={<ViewMeta />} /> */}
        <Route key="sponsors" path="/sponsors" element={<Sponsors />} />
        <Route
          key="route_sponsor_create"
          path="/sponsor/create"
          element={<CreateSponsor />}
        />
        <Route
          key="route_sponsor_edit"
          path="/sponsor/:id"
          element={<Sponsor />}
        />
        <Route
          key="route_edit_edition_id"
          path="/edition/bookings/edit/:id"
          element={<EditEditionBands />}
        />

        <Route key="route_polls" path="/polls" element={<Polls />} />
        <Route
          key="route_polls_edit"
          path="/poll/edit/:id"
          element={<PollLink />}
        />
        <Route
          key="route_polls_edit"
          path="/poll/result/:id"
          element={<PollResultsPage />}
        />
        <Route
          key="route_data_importer"
          path="/data-importer"
          element={<Importer />}
        />
        <Route
          key="route_csv_importer"
          path="/csv-import"
          element={<CsvImportTabs />}
        />
        <Route key="route_help_index" path="/help" element={<HelpIndex />} />
        <Route key="route_help_detail" path="/help/:slug" element={<HelpDetail />} />
      </Route>
    </Route>
  )
);

root.render(
  <React.StrictMode>
    <RouterProvider router={routes} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
